import React, { type ReactNode } from 'react';

import { ChildrenWrapper, DividerWrapper } from './styles';

export interface DividerProps {
    children?: ReactNode;
}

export function Divider({ children }: DividerProps) {
    const childrenMarkup = children ? <ChildrenWrapper>{children}</ChildrenWrapper> : null;

    return <DividerWrapper $partial={Boolean(childrenMarkup)}>{childrenMarkup}</DividerWrapper>;
}
